import { useEffect, useState } from "react";
import GetIcon from "../../utils/Icon";
import Button from "../Button/Button";
import { useGetDoctypePrintQuery, useGetDoctypePrintTypeQuery } from "../../store/api/globalapi";

function PrintModal({onClose,documentId,doctype,title = "Print Document"}) {
  const [selectedFormat, setSelectedFormat] = useState('');
  const [pdfUrl, setPdfUrl] = useState(null); 
  const { data: printFormats, isLoading: formatsLoading } = useGetDoctypePrintTypeQuery({filters: `[["Print Format","doc_type","=","${doctype}"]]`});
  const { data: printData, isLoading,refetch } = useGetDoctypePrintQuery({doctype,print_format: selectedFormat,name: documentId}, { skip: !selectedFormat });

  useEffect(() => {
    if (printFormats?.data?.length > 0 && !selectedFormat) {
      setSelectedFormat(printFormats.data[0].name);
    }
  }, [printFormats, selectedFormat]);

  useEffect(() => {
    if (!isLoading && printData) {
      const blob = new Blob([printData], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      setPdfUrl(url);
      return () => URL.revokeObjectURL(url);
    }
  }, [printData, isLoading]);

  const handlePrint = () => {
    if (pdfUrl) {
      const printWindow = window.open(pdfUrl);
      printWindow.onload = function() {
        printWindow.print();
      };
    }
  };

  return (
    <div className="modal-overlay" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div className="modal-content" style={{
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '8px',
        width: '80%',
        maxWidth: '1000px',
        maxHeight: '90vh',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <div className="modal-header" style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '20px'
        }}>
          <h3 style={{fontSize:'1.4rem'}}>{title}</h3>
          <button onClick={onClose} style={{
            background: 'none',
            border: 'none',
            fontSize: '20px',
            cursor: 'pointer',
            position:'relative',
            top:'-4px'
          }}>
            <GetIcon iconName="IoClose" size={19} />
          </button>
        </div>
        
        <div className="modal-body" style={{
          display: 'flex',
          flex: 1,
          gap: '20px',
          overflow: 'hidden',
        }}>
          <div className="print-options" style={{
            width: '200px',
            padding: '10px',
            borderRight: '1px solid #eee'
          }}>
            <div className="form-group" style={{ marginBottom: '10px' }}>
              <label style={{ display: 'block', marginBottom: '2px',fontSize:'0.8rem' }}>
                Print Format
              </label>
              <select 
                value={selectedFormat}
                className="form-control"
                onChange={(e) => setSelectedFormat(e.target.value)}
                disabled={formatsLoading}
                style={{
                  width: '100%',
                  fontSize:'0.8rem',
                  borderRadius: '4px',
                  border: '1px solid #ddd'
                }}
              >
                {formatsLoading ? (
                  <option>Loading formats...</option>
                ) : (
                  printFormats?.data?.map(format => (
                    <option key={format.name} value={format.name}>
                      {format.name}
                    </option>
                  ))
                )}
              </select>
            </div>
            
            <Button
              onClick={handlePrint}
              style={{ gap: '2px', height: '28px' }}
              className="createbtn d-flex w-100"
              disabled={isLoading || !pdfUrl || formatsLoading}
            >
              {isLoading ? 'Loading...' : 'Print'}
            </Button>
           
          </div>
          
          <div className="pdf-viewer" style={{
            flex: 1,
            overflow: 'auto',
            border: '1px solid #ddd',
            borderRadius: '4px',
            minHeight: '509px'
          }}>
            {isLoading ? (
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%'
              }}>
                Loading PDF...
              </div>
            ) : pdfUrl ? (
              <iframe
                src={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=0`}
                width="100%"
                height="500px"
                frameBorder="0"
                style={{
                  border: "none",
                  outline: "none",
                  backgroundColor: "white",
                }}
              />
            ) : (
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                color: '#666'
              }}>
                {selectedFormat ? 'No PDF available' : 'Select a format to preview'}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrintModal;